import axios from "../../../../axios";
import Cookies from "js-cookie";

export const CGetInterviewSchedule = async () => {
  const token = Cookies.get("ConsultantToken");

  return axios.post("/api/Consultant/GetInterviewScheduledCandidates", {
    token,
  });
};